import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

export default ({ style = { color: 'white' } }) => <FontAwesomeIcon icon={faChevronDown} style={style} />;
